export const getSection = (pathname?: string) => {
    return pathname?.match(/for-sale|to-rent|new-homes/g)?.[0];
};
